module.exports = __webpack_public_path__ + "img/img_quanyi03@2x.b0b32f63.png";